import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-resetpass',
  templateUrl: './resetpass.component.html',
  styleUrls: ['./resetpass.component.css']
})
export class ResetpassComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
